import { Navigate, Route, Routes } from 'react-router-dom'

import AdminStaffsPage from './staffs/AdminStaffsPage'
import ApiKeysPage from '@/pages/api-keys/ApiKeysPage'
import CreatePolicyPage from '@/pages/policies/CreatePolicyPage'
import CreateGroupPage from './groups/CreateGroupPage'
import CreateStaffPage from './staffs/CreateStaffPage'
import PluginsPage from './plugins/PluginsPage'
import PoliciesPage from '@/pages/policies/PoliciesPage'
import GroupsPage from './groups/GroupsPage'
import { StatisticsPage } from './statistics'
import PolicyPage from '@/pages/policies/PolicyPage'
import GroupPage from './groups/GroupPage'
import CreateApiKeyPage from '@/pages/api-keys/CreateApiKeyPage'
import ApiKeyPage from '@/pages/api-keys/ApiKeyPage'
import LicensesPage from '@/pages/licenses/LicensesPage'
import LicenseMonitorPage from '@/pages/licenses/LicenseMonitorPage'
import FormTemplatesPage from './forms/FormTemplatesPage'
import ViewFormTemplatePage from './forms/ViewFormTemplatePage'
import AdminPlanningsPage from './plannings/AdminPlanningsPage'
import { EstablishmentPage } from './establishment/EstablishmentPage'
import AdminKnowledgeBase from './knowledge/AdminKnowledgeBase'
import { DesmosActsPage } from './desmosacts/DesmosActsPage'
import MedicalActTemplatesPage from './medical-acts/MedicalActTemplatesPage'
import MedicalActRecordsPage from './medical-acts/MedicalActRecordsPage'
import DataExportPage from './data-export/DataExportPage'
import { AdminTimeTrackingDashboard } from '@/features/time-tracking'
import AdminAirtablePage from './airtable/AdminAirtablePage'

export function AdminPage() {
  return (
    <Routes>
      <Route path="/establishment" element={<EstablishmentPage />} />
      <Route path="/api-keys" element={<ApiKeysPage />} />
      <Route path="/airtable" element={<AdminAirtablePage />} />
      <Route path="/api-keys/create" element={<CreateApiKeyPage />} />
      <Route path="/api-keys/:apiKeyId" element={<ApiKeyPage />} />
      <Route path="/groups" element={<GroupsPage />} />
      <Route path="/groups/create" element={<CreateGroupPage />} />
      <Route path="/groups/:groupId" element={<GroupPage />} />
      <Route path="/licenses" element={<LicensesPage />} />
      <Route path="/licenses/:licenseId" element={<LicenseMonitorPage />} />
      <Route path="/plannings" element={<AdminPlanningsPage />} />
      <Route path="/policies" element={<PoliciesPage />} />
      <Route path="/policies/create" element={<CreatePolicyPage />} />
      <Route path="/policies/:policyId" element={<PolicyPage />} />
      <Route path="/plugins" element={<PluginsPage />} />
      <Route path="/staffs" element={<AdminStaffsPage />} />
      <Route path="/staffs/create" element={<CreateStaffPage />} />
      <Route path="/statistics" element={<StatisticsPage />} />
      <Route path="/forms" element={<FormTemplatesPage />} />
      <Route path="/forms/:templateId" element={<ViewFormTemplatePage />} />
      <Route path="/knowledge-base/*" element={<AdminKnowledgeBase />} />
      <Route path="/desmos-acts" element={<DesmosActsPage />} />
      <Route path="/medical-acts" element={<MedicalActTemplatesPage />} />
      <Route path="/medical-acts/records" element={<MedicalActRecordsPage />} />
      <Route path="/data-export" element={<DataExportPage />} />
      <Route path="/time-tracking" element={<AdminTimeTrackingDashboard />} />
      <Route path="/" element={<Navigate to="/admin/staffs" />} />
    </Routes>
  )
}

export default AdminPage
